(function ($) {
    // init variables
    let select2_inputs = $('.form-group-default-select2 select');

    // init plugins
    select2_inputs.select2();

})(jQuery);

$('#quoteForm').keypress(
    function (event) {
        if (event.which == '13') {
            event.preventDefault();
        }
    });

/**
 * Show toastr notification
 *
 * @param message
 * @param type
 */
let notify = (message, type) => {

    let title = `${type[0].toUpperCase()}${type.slice(1)}!`;

    toastr[type]('<strong>' + title + '</strong><br>' + message)
}

/**
 * Format price with a dollar sign
 * @param price price to format
 * @returns {string}
 */
const formatPrice = (price) => {
    if (price < 0) {
        return '-$' + accounting.formatMoney(Math.abs(price), "", 2, ",", ".");
    }
    return '$' + accounting.formatMoney(price, "", 2, ",", ".");
}

/**
 * Show loading animation
 */
const helloSpinnyBoi = () => {
    $('.preloader').css({'display': 'flex'});
}

/**
 * Hide loading animation
 */
const byeSpinnyBoi = () => {
    $('.preloader').hide();
}

/**
 * Get stand string for a given boltpattern
 * @param boltpattern
 * @param isFps
 */
function getStandardBoltpattern(boltpattern, isFps) {
    let standardBP = '';
    $.ajax({
        type: "post",
        url: api_endpoints['standard_boltpattern'],
        async: false,
        data: {
            boltpattern: boltpattern,
            isFps: isFps
        }
    }).done(function (result) {
        standardBP = result;
    });

    return standardBP;
}

/**
 * Enable/Disable Machine Type, Trim, and Drive when Function Powersports is selected
 * @param is_fps flag to determine if vendor is Function Powersports
 */
function toggleFPS(is_fps) {
    let ymm_machine_type = $('#machine_type'),
        ymm_trim = $('#trim'),
        ymm_drive = $('#drive'),
        ymm_cab = $('#cab'),
        ymm_package = $('#package'),
        ymm_year = $('#year'),
        ymm_make = $('#make'),
        ymm_model = $('#model'),
        ymm_suspension = $('#suspension');

        if (is_fps) {
            ymm_machine_type.parent('div').parent('div').show();
            ymm_trim.parent('div').parent('div').hide();
            ymm_drive.parent('div').parent('div').hide();
            $('#cab-wrapper').hide();
            $('#package-wrapper').hide();
            ymm_cab.val('');
            ymm_package.val('');
            ymm_year.val('');
            ymm_year.val('').trigger('change');
            ymm_make.val('');
            ymm_make.val('').trigger('change');
            ymm_model.val('');
            ymm_model.val('').trigger('change');
            ymm_suspension.val('');
            ymm_suspension.val('').trigger('change');
        } else {
            ymm_trim.parent('div').parent('div').show();
            ymm_drive.parent('div').parent('div').show();
            ymm_machine_type.parent('div').parent('div').hide();
            ymm_machine_type.val('');
            ymm_machine_type.val('').trigger('change');
        }
    }

function isFps() {
    let vendor = $('#vendor');
    return vendor.val() === 'Function Powersports' || vendor.val() === 'Employee FPS' ? 1 : 0
}

function isOT(){
    let vendor = $('#vendor');
    return vendor.val() === 'Only Tires' ? 1 : 0
}
function isVendor(){
    let vendor = $('#vendor');
    return (vendor.val() === 'Vision Wheel' || vendor.val() === 'Hardrock Offroad') ? 1 : 0
}

function toggleOT(is_ot){
    if(is_ot){
        let rows = $(".item-row");
        $.each(rows, (index, row) => {
            if(row.attributes['data-item-type'].value !== 'tire' && row.attributes['data-item-type'].value !== 'discount'){
                row.style.display = 'none';
            }
        });
    }
}

function toggleVendor(is_vendor) {
    $(".item-row, .item-row.upsell").each((index, row) => {
        const type = row.getAttribute('data-item-type');
        if (type == 'suspension' || type == 'shine') {
            if (is_vendor) {
                $(row).hide();
            } else {
                $(row).show();
            }
        }
    });
}

export {notify, formatPrice, helloSpinnyBoi, byeSpinnyBoi, getStandardBoltpattern, toggleFPS, isFps, isOT, toggleOT, isVendor, toggleVendor};